<template>
  <div style="padding-top:10px;height:auto;">

    <iframe id='mainFrame' name='mainFrame' ref='mainFrame' src="../../../../static/index.html" scrolling="no" width="100%" height="100%"></iframe>

  </div>
</template>

<script>
export default {
  data() {
    return {
      user: "",
      userID: "",
    }
  },
  methods: {

  },
  watch: {
  },
  mounted() {
    // this.user = localStorage.getItem('user_data');
    // this.user = JSON.parse(this.user)
    // this.userID = this.user.id
    // alert(this.userID)
  }
}
</script>

<style lang="less">
#mainFrame {
  width: 100%;
  height: 1030px;
}
</style>